import script from "./Tabbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabbar.vue?vue&type=script&setup=true&lang=js"

import "./Tabbar.vue?vue&type=style&index=0&id=d3e6e45e&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3e6e45e"]])

export default __exports__